export enum DeviceType {
  IOS,
  ANDROID,
  UNKNOWN,
  IOS_SANDBOX,
}
export default DeviceType;
